'use strict';
//
// This state displays the admin Template Packs page
//
import * as angular from 'angular';

angular.module('flowingly.runner.templates').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state('app.runner.templates.admin.packs', {
    url: '/packs',
    params: { title: 'Template Packs' },
    templateUrl:
      'Client/runner.templates/admin/packs/runner.templates.admin.packs.tmpl.html',
    controller: 'runnerTemplatesPacksController',
    controllerAs: 'ctrl'
  });
}
